import createComponent, {
  type ElementWithProps
} from '@carvana/merch-components/createComponent';
import cx from 'classnames';

const baseStyles =
  'gap-md inline-flex h-[44px] w-full cursor-pointer items-center justify-center whitespace-nowrap rounded-full px-xl sm:px-2xl t-strong-sm u:text-text-strong u:hover:bg-background-weak u:active:bg-background-muted-subtle';

export const NavLink = createComponent<
  ElementWithProps<{ selected?: boolean }>
>('a', props => ({
  className: cx(baseStyles, {
    'bg-background-primary-subtle text-text-primary hover:bg-background-primary-subtle hover:text-text-strong active:bg-background-primary-subtle':
      props.selected
  })
}));

export const NavButton = createComponent('button', {
  className: cx(baseStyles, '!p-lg u:bg-background-default')
});

export const Container = createComponent('div', {
  className:
    'flex items-center justify-between gap-x-xl pt-lg sm:pb-xl sm:pt-xl'
});
